import {
  Coordinates,
  CoordinatesResponse,
  GeocodeObject,
  GISResponse,
  ReverseGISResponse,
} from '../../../@types/geographicInformationSystem-types'
import { coordinatesToApp } from './coordinates'

export const geocodeToApp = (response: GISResponse): GeocodeObject => ({
  geocodingResults: geocodingResultToApp(response.geocodingResults),
})

export const reversGeoCodeToApp = (response: ReverseGISResponse): GeocodeObject => ({
  geocodingResults: geocodingResultToApp(response.reverseGeocodingResults),
})

export const geocodingResultToApp = (result: CoordinatesResponse[]): Coordinates[] =>
  result.map((coordinates) => coordinatesToApp(coordinates))
